import React, { useState } from "react"
import { DatePicker, Space, Input, Select } from "antd"
import { INVOICE_STATUSES } from "../../constants/invoiceStatus"

const TransactionFilters = ({filters, onFiltersChange}) => {
  const [searchField, setSearchField] = useState("trackingNo")

  const searchBy = (
    <Select defaultValue="trackingNo" className="select-before" onChange={value => setSearchField(value)}>
      <Select.Option value="trackingNo">Tracking No</Select.Option>
      <Select.Option value="userEmail">User Email</Select.Option>
      <Select.Option value="transactionId">Transaction Id</Select.Option>
      <Select.Option value="invoiceNo">Invoice No</Select.Option>
    </Select>
  );

  return (
    <Space size="large" wrap>
      <div>
        Transaction Date :{` `}
        <DatePicker.RangePicker
          value={[filters.startDate, filters.endDate]}
          onChange={dates => (dates 
              ? onFiltersChange({...filters, startDate: dates[0], endDate: dates[1]}) 
              : onFiltersChange({...filters, startDate: undefined, endDate: undefined})
          )}
        />
      </div>

      <div>
      Search :{` `}
        <Input.Search 
          addonBefore={searchBy}
          placeholder="Search" 
          onSearch={term => onFiltersChange({...filters, search: term, searchField }) } 
        />
      </div>

      <div>
        User Tagging :{` `}
        <Select 
          placeholder="ALL"
          style={{ width: 200 }}
          allowClear 
          onChange={value => onFiltersChange({...filters, tagging: value})}
        >
          <Select.Option value="Credit User">Credit User</Select.Option>
          <Select.Option value="Topup User">Topup User</Select.Option>
        </Select>
      </div>

      <div>
        Invoice Status :{` `}
        <Select 
          placeholder="ALL"
          style={{ width: 200 }}
          allowClear 
          onChange={value => onFiltersChange({...filters, invoiceStatus: value})}
        >
          {Object.keys(INVOICE_STATUSES).map(invoiceStatus => 
            <Select.Option value={invoiceStatus}>{invoiceStatus}</Select.Option>
          )}
        </Select>
      </div>

      <div>
        Invoice Consolidate :{` `}
        <Select 
          placeholder="ALL"
          style={{ width: 200 }}
          allowClear 
          onChange={value => onFiltersChange({...filters, invoiceIsConsolidate: value})}
        >
          <Select.Option value="true">Yes</Select.Option>
          <Select.Option value="false">No</Select.Option>
        </Select>
      </div>
    </Space>
  )
}

export default TransactionFilters;
